module.exports = {
	// API_URL: 'https://webapi.ycvision.cn/',
	API_URL: 'https://api.hl679.com',
	
	// API_URL: 'https://test-api.hl679.com',
	// uploadUrl:"https://api.hnjl679.com",
	AppId: 'wx9a5b50a986c606d7',
	version:'1.0.0',
	client_id:'bms-salesperson',
	client_secret:'l9dVVV9NhLMVNj3I',
	fileAppId:"10008",
	imageUrl: 'https://clock.vmeshou.com/tuijianguan',
	// 文件系统appKey
	fileAppKey : "my2xuLmdYUJaowERL2Ru9KMjVODOKRy9",
	scope:'app',
}


// WEBPACK FOOTER //
// ./src/utils/config/pro.config.js